(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnf-feature-highlights"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.tnf-feature-highlights');
    sections.forEach((section) => {
      const viewport = section.querySelector('[data-carousel]');
      const prevButton = section.querySelector('[data-carousel-prev]');
      const nextButton = section.querySelector('[data-carousel-next]');
      if (!viewport || !prevButton || !nextButton) {
        return;
      }

      const originalItems = Array.from(viewport.children);
      const originalCount = originalItems.length;
      const userAgent = window.navigator.userAgent;
      const isSafariLike = /Safari/i.test(userAgent) && !/Chrome|Chromium|CriOS|EdgiOS|FxiOS|OPiOS|Android/i.test(userAgent);

      if (originalCount === 0) {
        return;
      }

      let duplicateSets = 1;
      const appendCloneSet = () => {
        originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          viewport.appendChild(clone);
        });
        duplicateSets += 1;
      };

      const ensureLoopContent = () => {
        if (duplicateSets < 2) {
          appendCloneSet();
        }

        if (viewport.clientWidth === 0) {
          appendCloneSet();
          return;
        }

        const targetWidth = viewport.clientWidth * 3;
        let safety = 0;
        while (viewport.scrollWidth < targetWidth && safety < 6) {
          appendCloneSet();
          safety += 1;
        }
      };

      ensureLoopContent();

      let loopDistance = 0;
      let canAutoScroll = false;

      const refreshLoopMetrics = () => {
        const referenceChild = viewport.children[originalCount];
        loopDistance = referenceChild ? referenceChild.offsetLeft : 0;

        if (!loopDistance && viewport.scrollWidth > viewport.clientWidth) {
          loopDistance = viewport.scrollWidth - viewport.clientWidth;
        }

        const minLoopDistance = Math.max(32, viewport.clientWidth * 0.05);
        canAutoScroll = loopDistance > minLoopDistance;
      };

      const normalizeLoop = () => {
        if (loopDistance > 0) {
          while (viewport.scrollLeft >= loopDistance) {
            viewport.scrollLeft -= loopDistance;
          }
          while (viewport.scrollLeft < 0) {
            viewport.scrollLeft += loopDistance;
          }
        }
      };

      const updateControls = () => {
        if (loopDistance > 0) {
          prevButton.disabled = false;
          nextButton.disabled = false;
          return;
        }

        const maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        prevButton.disabled = viewport.scrollLeft <= 2;
        nextButton.disabled = viewport.scrollLeft >= maxScroll - 2;
      };

      const scrollByStep = (direction) => {
        const step = viewport.clientWidth * 0.8;

        if (isSafariLike) {
          viewport.scrollLeft += step * direction;
          normalizeLoop();
          updateControls();
          return;
        }

        viewport.scrollBy({ left: step * direction, behavior: 'smooth' });
      };

      let autoScrollFrame = null;
      let autoScrollResumeTimeout = null;
      let lastFrameTimestamp = null;
      let autoScrollCarry = 0;
      const autoScrollSpeed = 56; // pixels per segundo
      const autoScrollResumeDelay = 2400;

      const cancelAutoScroll = () => {
        if (autoScrollFrame) {
          window.cancelAnimationFrame(autoScrollFrame);
          autoScrollFrame = null;
        }
        if (autoScrollResumeTimeout) {
          window.clearTimeout(autoScrollResumeTimeout);
          autoScrollResumeTimeout = null;
        }
        lastFrameTimestamp = null;
        autoScrollCarry = 0;
      };

      const autoScrollStep = (timestamp) => {
        if (!lastFrameTimestamp) {
          lastFrameTimestamp = timestamp;
        }

        const delta = timestamp - lastFrameTimestamp;
        lastFrameTimestamp = timestamp;

        if (canAutoScroll) {
          const deltaPixels = (autoScrollSpeed * delta) / 1000;

          if (isSafariLike) {
            autoScrollCarry += deltaPixels;

            const wholePixels = autoScrollCarry > 0
              ? Math.floor(autoScrollCarry)
              : Math.ceil(autoScrollCarry);

            if (wholePixels !== 0) {
              viewport.scrollLeft += wholePixels;
              autoScrollCarry -= wholePixels;
            }
          } else {
            viewport.scrollLeft += deltaPixels;
          }

          normalizeLoop();
        }

        updateControls();
        autoScrollFrame = window.requestAnimationFrame(autoScrollStep);
      };

      const startAutoScroll = () => {
        if (!canAutoScroll) {
          return;
        }
        cancelAutoScroll();
        viewport.classList.add('is-autoscrolling');
        viewport.style.setProperty('scroll-snap-type', 'none');
        viewport.style.setProperty('scroll-behavior', 'auto');
        viewport.style.setProperty('-webkit-overflow-scrolling', 'auto');
        autoScrollFrame = window.requestAnimationFrame(autoScrollStep);
      };

      const resumeAutoScroll = (delay = autoScrollResumeDelay) => {
        if (!canAutoScroll) {
          return;
        }
        cancelAutoScroll();
        autoScrollResumeTimeout = window.setTimeout(() => {
          startAutoScroll();
        }, delay);
      };

      const pauseAutoScroll = () => {
        cancelAutoScroll();
        viewport.classList.remove('is-autoscrolling');
        viewport.style.removeProperty('scroll-snap-type');
        viewport.style.removeProperty('scroll-behavior');
        viewport.style.removeProperty('-webkit-overflow-scrolling');
      };

      const handleNavigation = (direction) => {
        pauseAutoScroll();
        if (direction < 0 && loopDistance > 0 && viewport.scrollLeft <= 2) {
          viewport.scrollLeft += loopDistance;
        }
        scrollByStep(direction);
        resumeAutoScroll();
      };

      prevButton.addEventListener('click', () => handleNavigation(-1));
      nextButton.addEventListener('click', () => handleNavigation(1));

      let scrollFrame = null;
      viewport.addEventListener('scroll', () => {
        if (viewport.classList.contains('is-autoscrolling')) {
          return;
        }

        if (scrollFrame) {
          return;
        }

        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = null;
          normalizeLoop();
          updateControls();
        });
      }, { passive: true });

      let isDragging = false;
      let dragStartX = 0;
      let dragStartScroll = 0;

      if (isSafariLike) {
        viewport.addEventListener('touchstart', () => {
          pauseAutoScroll();
        }, { passive: true });

        viewport.addEventListener('touchend', () => {
          updateControls();
          resumeAutoScroll();
        }, { passive: true });

        viewport.addEventListener('touchcancel', () => {
          updateControls();
          resumeAutoScroll();
        }, { passive: true });
      } else {
        viewport.addEventListener('pointerdown', (event) => {
          if (event.button !== 0 && event.pointerType === 'mouse') {
            return;
          }
          pauseAutoScroll();
          if (loopDistance > 0 && viewport.scrollLeft <= 2) {
            viewport.scrollLeft += loopDistance;
          }
          isDragging = true;
          dragStartX = event.clientX;
          dragStartScroll = viewport.scrollLeft;
          viewport.classList.add('is-dragging');
          if (viewport.setPointerCapture) {
            viewport.setPointerCapture(event.pointerId);
          }
        });

        const endDrag = (event) => {
          if (!isDragging) {
            return;
          }
          isDragging = false;
          viewport.classList.remove('is-dragging');
          if (viewport.hasPointerCapture && viewport.hasPointerCapture(event.pointerId)) {
            viewport.releasePointerCapture(event.pointerId);
          }
          updateControls();
          resumeAutoScroll();
        };

        viewport.addEventListener('pointermove', (event) => {
          if (!isDragging) {
            return;
          }
          event.preventDefault();
          const delta = event.clientX - dragStartX;
          viewport.scrollLeft = dragStartScroll - delta;
          normalizeLoop();
          updateControls();
        });

        viewport.addEventListener('pointerup', endDrag);
        viewport.addEventListener('pointerleave', endDrag);
        viewport.addEventListener('pointercancel', endDrag);
      }

      viewport.addEventListener('dragstart', (event) => event.preventDefault());

      const handleResize = () => {
        ensureLoopContent();
        refreshLoopMetrics();
        updateControls();
        resumeAutoScroll(800);
      };

      if ('ResizeObserver' in window) {
        new ResizeObserver(handleResize).observe(viewport);
      } else {
        window.addEventListener('resize', handleResize);
      }

      refreshLoopMetrics();
      updateControls();
      resumeAutoScroll(1200);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
